
<cal-cpa-add-mapping [resources]="resources"></cal-cpa-add-mapping>
<cal-calsiumlist-listing [config]="consumingPlanningAreaMappingsConfig" [ListBodyData]="consumingPlanningAreaMappings | async" 
(sortTriggered)="onSort($event)"
  (filterTriggered)="onFilter($event)" [isLoading]="isLoading | async"
  (clearFilterAndSortingTriggered)="onClearFilterAndSorting()"
  [dataTotalCount]="totalCount | async" [filterExpression]="filterExpression | async"></cal-calsiumlist-listing>
<cal-pagination [paging]="paging | async" (pageChange)="onPaging($event)" [dataTotalCount]="totalCount | async"></cal-pagination>
